<audio controls>
    <source [src]="value+cid">
</audio>